// Module
var code = `<div class="spinner"> <div class="spinner_r1"></div> <div class="spinner_r2"></div> <div class="spinner_r3"></div> <div class="spinner_r4"></div> <div class="spinner_r5"></div> </div>`;
// Exports
export default code;